import React from "react";
import { ContentImageDesc } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import SectionHeader from "@/components/SectionHeader";
import Image from "@/components/Image";
import ContentDescriptionComponent from "@/components/PagePiller/components/ContentDescription";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import styles from "./ContentImageDesc.module.scss";

interface ContentImageDescProps {
  data: ContentImageDesc;
  userAgent?: DeviceInfo;
  registerRef?: RegisterRefType;
}

const ContentImageDescComponent: React.FC<ContentImageDescProps> = ({ data, userAgent, registerRef }) => {
  const { Heading: title, ShortDescription: description, Image: ImageData, Description: additionalData } = data;
  const imageData = ImageData?.data?.attributes;

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`${styles.container} container scrollMargin spacingBetweenSections`}
    >
      <SectionHeader title={title} subTitle={description} userAgent={userAgent} desktopAlignLeft cardSpacing="0" />
      <div className={`${styles.imageWrapper} ${!additionalData ? styles.zeroSpacing : ""}`}>
        <Image
          src={imageData?.url}
          alt={imageData?.alternativeText || "Content Banner"}
          width={userAgent?.isDesktop ? 750 : 320}
          height={userAgent?.isDesktop ? 208 : 125}
        />
      </div>
      {additionalData && (
        <div className={styles.descWrap}>
          <ContentDescriptionComponent data={additionalData} />
        </div>
      )}
    </section>
  );
};

export default ContentImageDescComponent;
